module.exports = __webpack_public_path__ + "img/file_type_t.6aaa336.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/file_type_t.png
// module id = jaTd
// module chunks = 12 13 14 17 26